<template>
  <transition name="fade" mode="out-in" appear>

    <div class="comp-verification-event-media">

      <template v-if="mediaType === 'video'">

        <CompVerificationEventVideo v-on:onVideoErr="videoError"/>

      </template>
      <template v-else-if="mediaType === 'snapshot'">

        <CompVerificationEventSnapshot/>

      </template>
      <template v-else>

        <CompMediaPlaceholder/>

        <div class="no-media-text-wrapper">
          <div class="no-media-text">No media available</div>
        </div>

      </template>

    </div>

  </transition>
</template>

<script>
import CompMediaPlaceholder from '@/components/CompMediaPlaceholder'
import CompVerificationEventVideo from '@/components/CompVerificationEventVideo'
import CompVerificationEventSnapshot from '@/components/CompVerificationEventSnapshot'
export default {
  name: 'comp-verification-event-media',
  components: {
    CompMediaPlaceholder,
    CompVerificationEventVideo,
    CompVerificationEventSnapshot
  },
  props: {
    infoFontSize: {
      type: String,
      default: function () {
        return '16px'
      }
    },
    autoPlay: {
      type: Boolean,
      default: function () {
        return true
      }
    },
    isControllable: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  computed: {
    verificationEventMedias: function () {
      return this.$store.getters.verificationEventMedias
    },
    verificationEventRecords: function () {
      return this.$store.getters.verificationEventRecords
    },
    statusGetVerificationEventMedias: function () {
      return this.$store.getters.statusGetVerificationEventMedias
    },
    statusCheckVerificationVideoCodec: function () {
      return this.$store.getters.statusCheckVerificationVideoCodec
    }
  },
  data: function () {
    return {
      mediaType: '',
      isVideoMediaAvaliable: false,
      isSnapshotMediaAvaliable: false,
      isVideoErr: false
    }
  },
  watch: {
    statusGetVerificationEventMedias: function () {
      this.updateMediaPlayer()
    },
    statusCheckVerificationVideoCodec: function () {
      if (this.statusCheckVerificationVideoCodec === 'successful') {
        this.updateMediaPlayer()
      }
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy: function () {
  },
  methods: {
    init: function () {
      this.updateMediaPlayer()
      this.getVerificationEvent()
    },
    getVerificationEvent: function () {
      this.$logger.info('getVerificationEvent')
      this.$store.dispatch('getVerificationEvent')
    },
    // ////////////////////////////////////////
    // UPDATE VARS - Media Player
    // ////////////////////////////////////////
    updateMediaPlayer: function () {
      // CHECK 1
      if (!this.verificationEventMedias) return

      // INIT 1
      this.isVideoMediaAvaliable = false
      this.isSnapshotMediaAvaliable = false
      // GET recordInfo - VIDEO (MP4) and Snapshot (JPG)
      for (let index = 0; index < this.verificationEventMedias.length; index++) {
        // CHECK
        let recordInfo = {...this.verificationEventMedias[index]}
        if (!(recordInfo instanceof Object)) continue

        // CHECK
        if (recordInfo.format !== 'mp4' && recordInfo.format !== 'jpg') continue
        if (!recordInfo.statusInfo.completed) continue

        // UPDATE - isVideoMediaAvaliable
        if (recordInfo.format === 'mp4') {
          if (recordInfo.statusInfo.codec === 'h264') {
            this.isVideoMediaAvaliable = true
          } else if (recordInfo.statusInfo.codec !== null) {
            this.isVideoErr = true
          } else {
            let videoUrl = recordInfo.url
            let recordId = recordInfo.recordId
            let videoIndex = index
            this.downloadEventMedia(videoIndex, recordId, videoUrl)
          }
          continue
        }
        // UPDATE - isSnapshotMediaAvaliable
        if (recordInfo.format === 'jpg') {
          this.isSnapshotMediaAvaliable = true
        }
      }

      // UPDATE mediaType - HAS VIDEO
      if (this.isVideoMediaAvaliable) {
        this.mediaType = 'video'
        return
      }
      // UPDATE mediaType - HAS SNAPSHOT
      if (this.isSnapshotMediaAvaliable) {
        this.mediaType = 'snapshot'
      }

      if (!this.isSnapshotMediaAvaliable && !this.isVideoMediaAvaliable && this.isVideoErr) {
        this.$emit('onEventErr', true)
      }
    },
    videoError: function () {
      this.isVideoErr = true
      this.mediaType = 'snapshot'
    },
    downloadEventMedia: function (videoIndex, recordId, videoUrl) {
      this.$logger.info('downloadEventVideo: requested: recordId({recordId})'
        .replace('{recordId}', recordId))
      this.$store.dispatch('getVerificationEventRecord', {
        snapshotIndex: videoIndex,
        recordId: recordId,
        url: videoUrl
      })
    }
  }
}
</script>

<style scoped>
.comp-verification-event-media {
  /* common */
  background-color: #fff;
  color: #333;
  font-size: 14px;
  /* outline: 1px solid #fff; */
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
}

.comp-verification-event-media .no-media-text-wrapper {
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
  /* position */
  position: absolute;
  bottom: 0;
  left: 0;
}
.comp-verification-event-media .no-media-text-wrapper .no-media-text {
  /* common */
  font-size: 1em;
  color: #fff;
  background-color: hsla(0, 0%, 20%, 1);
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/CompVerificationEventMedia.vue